import * as _ from 'lodash';
import { IRecipient } from '@nkr/models/index'
import { Label, Panel } from 'react-bootstrap';
import { RecipientDetailsWrapper } from './styles';

interface IProps {
    recipient: IRecipient
}

const RecipientDetails = (props: IProps) => {
    let { alias, hlaAvoids, bloodType, age, gender, height, weight, exportableDaysInNkr, storedPrePrefMatches, storedPostPrefMatches, storedExportableCount, cpra4 } = props.recipient;
    let { aAvoids, bAvoids, drAvoids, bwAvoids, cwAvoids, dqAvoids, dpAvoids, dqaAvoids, avoidDr51, avoidDr52, avoidDr53 } = hlaAvoids;

    let hlaAvoidsCount =
        aAvoids.length +
        bAvoids.length +
        drAvoids.length +
        bwAvoids.length +
        cwAvoids.length +
        dqAvoids.length +
        dpAvoids.length +
        dqaAvoids.length +
        (avoidDr51 ? 1 : 0) +
        (avoidDr52 ? 1 : 0) +
        (avoidDr53 ? 1 : 0);

    let prePrefMatchPercent = _.round(storedExportableCount > 0 ? storedPrePrefMatches / storedExportableCount * 100 : 0, 1);
    let postPrefMatchPercent = _.round(storedExportableCount > 0 ? storedPostPrefMatches / storedExportableCount * 100 : 0, 1);

    return (
        <Panel>
            <Panel.Heading>Recipient Details</Panel.Heading>
            <Panel.Body>
                <RecipientDetailsWrapper>
                    <tbody>
                        <tr>
                            <td className='rd-label'>Alias:</td>
                            <td className='rd-value'>{alias}</td>

                            <td className='rd-label'>Antibodies:</td>
                            <td className='rd-value'>{hlaAvoidsCount}</td>

                            <td className='rd-label'>Blood Type:</td>
                            <td className='rd-value'>{bloodType != '' ? bloodType : <Label bsStyle='danger'>not specified</Label>}</td>
                        </tr>

                        <tr>
                            <td className='rd-label'>Age:</td>
                            <td className='rd-value'>{age}</td>

                            <td className='rd-label'>Gender:</td>
                            <td className='rd-value'>{gender}</td>

                            <td className='rd-label'>Height (cm):</td>
                            <td className='rd-value'>{height}</td>

                            <td className='rd-label'>Weight (kg):</td>
                            <td className='rd-value'>{weight}</td>

                            <td className='rd-label'>cPRA:</td>
                            <td className='rd-value'>{cpra4}</td>
                        </tr>

                        <tr>
                            <td className='rd-label'>Days in NKR:</td>
                            <td className='rd-value'>{exportableDaysInNkr}</td>

                            <td className='rd-label'>Pre-Pref Matches:</td>
                            <td className='rd-value'>{storedPrePrefMatches}</td>

                            <td className='rd-label'>Post-Pref Matches:</td>
                            <td className='rd-value'>{storedPostPrefMatches}</td>

                            <td className='rd-label'>Pre-Pref Match Power:</td>
                            <td className='rd-value'>{prePrefMatchPercent}%</td>

                            <td className='rd-label'>Post-Pref Match Power:</td>
                            <td className='rd-value'>{postPrefMatchPercent}%</td>
                        </tr>
                    </tbody>
                </RecipientDetailsWrapper>
            </Panel.Body>
        </Panel>
    );
}

export default RecipientDetails;